module.exports = __webpack_public_path__ + "static/company-kv-c17e96a8a1e9afcffb50783106fe4bd6.jpg";